import gql from 'graphql-tag'
import { get } from 'ts-object-path'
import { useQuery } from '@apollo/react-hooks'
import {
  ProfitChartByClientId_clientCharts,
  ProfitChartByClientId_clientChartsVariables
} from '../../../_generated/ProfitChartByClientId_clientCharts'
import { Precision } from '../../../_generated/globalTypes'

export const QUERY = gql`
query ProfitChartByClientId_clientCharts($id: ID!, $precision: Precision!) {
  charts {
    byClientId(id: $id) {
      id: clientId
      profit(precision: $precision) {
        begin
        valuesCount
        values
        labels
        currency
      }
    }
  }
}`

export type Q = ProfitChartByClientId_clientCharts
export type V = ProfitChartByClientId_clientChartsVariables
export type R = Q['charts']['byClientId']['profit']

export const parseData = (data: Q): R => {
  return get(data, p=> p.charts.byClientId.profit)
}

export function Use(clientId: string) {
  const query = useQuery<Q, V>(
      QUERY,
      {
          variables: {
              id: clientId,
              precision: Precision.MONTH
          }
      }
  )

  const { loading, error, data } = query

  return { loading, error, data: parseData(data) }
}
